export enum MigrationOutHook {
  PreSignal = '0',
  PostSignal = '1',
  PreMigrate = '2',
  PostMigrate = '3',
  PostCancel = '4',
}
